import React, { useContext } from "react";
import { RouterContext } from "../../../../contexts/routerContext";

import IconTalk from "../../../../assets/images/icon-tallk.svg";
import { AiOutlineHome, AiOutlineSend } from "react-icons/ai";
import { TiContacts } from "react-icons/ti";
import { BsGear } from "react-icons/bs";
import { IoCallOutline } from "react-icons/io5";

import { Menu } from "./menu";
import { MenuItem } from "./menu-item";

import { Container } from "./styles";

const Aside = () => {
  const { router, setRouter } = useContext(RouterContext);

  return (
    <Container>
      <Menu>
        <>
          {/*<MenuItem*/}
          {/*  icon={AiOutlineHome}*/}
          {/*  status={router === "home" ? "active" : "inative"}*/}
          {/*  click={() => setRouter('home')}*/}
          {/*/>*/}
          <MenuItem
            icon={IoCallOutline}
            status={router === "make-a-call" ? "active" : "inative"}
            click={() => setRouter('make-a-call')}
          />
          {/*<MenuItem*/}
          {/*  icon={AiOutlineSend}*/}
          {/*  status={router === "send-messages" ? "active" : "inative"}*/}
          {/*  click={() => setRouter('send-messages')}*/}
          {/*/>*/}
          {/*<MenuItem*/}
          {/*  icon={TiContacts}*/}
          {/*  status={router === "schedule" ? "active" : "inative"}*/}
          {/*  click={() => setRouter('schedule')}*/}
          {/*/>*/}
          {/*<MenuItem*/}
          {/*  icon={BsGear}*/}
          {/*  status={router === "settings" ? "active" : "inative"}*/}
          {/*  click={() => setRouter('settings')}*/}
          {/*/>*/}
        </>
      </Menu>
      <Menu>
        <>
          <img
            src="https://wbf.tallk.me/static/media/logo.svg"
            alt="Logo Tallk-me"
          />
        </>
      </Menu>
    </Container>
  );
};

export default Aside;
